import { Badge, Box, ClickAwayListener, IconButton, Paper, Popper, useMediaQuery, useTheme } from '@mui/material';
import { Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useRef, useState } from 'react';
import Transitions from 'components/@extended/Transitions';
import NotificationList from './NotificationList';
import { useGetNotificationCountQuery } from 'api/notification';

const AppNotification = () => {
  const anchorRef = useRef<any>(null);
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState<boolean>(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const { data: notificationCount } = useGetNotificationCountQuery(undefined, {
    pollingInterval: 120000, // Fetch count for every 2 minutes // Need to fix session issue if we need this
    keepUnusedDataFor: 0 // Clear cache immediately after unmount,
  });

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Tooltip placement="top" title={'Notification'}>
        <IconButton size="small" className="" onClick={handleToggle} ref={anchorRef}>
          <Badge badgeContent={notificationCount} color="secondary" sx={{ '& .MuiBadge-badge': { top: 2, right: 4 } }}>
            <NotificationsIcon color="primary" className="breacrumbs-title-icons" />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popper
        placement={matchesXs ? 'bottom' : 'bottom-end'}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [matchesXs ? -5 : 0, 9]
              }
            }
          ]
        }}
        sx={{ zIndex: 1300 }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position={matchesXs ? 'top' : 'top-right'} sx={{ overflow: 'hidden' }} in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                borderRadius: 1.5,
                width: '100%',
                minWidth: 285,
                maxWidth: 420,
                [theme.breakpoints.down('md')]: {
                  maxWidth: 285
                }
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <Box>
                  <NotificationList notificationCount={notificationCount || 0} />
                </Box>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default AppNotification;
